import {
  NavigationMenuOrganism,
  PageContentAtom
} from '@justomx/atlas-components'

import { StackAtom } from 'components/atoms/Stack.atom'
import { InstructionsMolecule } from 'components/molecule/Instructions.molecule'
import { ShipmentCardOrganism } from 'components/organisms/ShipmentCard.organis'
import { useSessionData } from 'hooks/session.hook'
import { useShipment } from './Shipment.hook'

const ShipmentPage = () => {
  const { user, country, warehouse, logout } = useSessionData()
  const { transfers, actions } = useShipment()

  return (
    <>
      <NavigationMenuOrganism
        title="Embarque"
        country={country}
        userEmail={user.username}
        userName={user.firstName}
        version="13.0.1"
        warehouseName={warehouse?.coreDescription || 'Pruebas'}
        onLogout={logout}
        menuItems={user.menuItems || []}
      />

      <PageContentAtom>
        <StackAtom $direction="column" $gap={24}>
          <InstructionsMolecule
            lines={['Selecciona la solicitud.']}
          ></InstructionsMolecule>

          <StackAtom $direction="column" $gap={16}>
            {transfers.map((transferData) => (
              <ShipmentCardOrganism
                key={transferData.transferId}
                transferData={transferData}
                onClick={() => {
                  actions.goToPreparation(
                    transferData.transferId,
                    transferData.docNum
                  )
                }}
              />
            ))}
          </StackAtom>
        </StackAtom>
      </PageContentAtom>
    </>
  )
}

export default ShipmentPage
